import { environment } from '@appEnvironments/environment';

// API - Endpoints
const { baseUrl } = environment;
export const apiUrl = `${baseUrl}/api`;

// AUTH
export const LOGIN_URL = `${apiUrl}/auth/login`;
export const REFRESH_TOKEN_URL = `${apiUrl}/auth/refresh`;
export const LOGOUT_URL = `${apiUrl}/auth/logout`;

// LOCATION
export const GET_PROVINCE_URL = `${apiUrl}/provinces`;
export const GET_CITY_URL = `${apiUrl}/cities/pagination`;

// TODO - REVIEW AND REMOVE IF NOT USED
export const CUSTOMERS_URL = `${apiUrl}/customers`;
export const CONTRACTS_EXPIRE_URL = `${apiUrl}/contracts-close-to-expire`;
export const REPORTS_URL = `${apiUrl}/reports`;

export const CUSTOMER_EXCEPTIONS_URL = 'organismexceptionsbycustomer';
export const ORGANISM_EXCEPTIONS_URL = '/officialorganisms/pagination';
export const FEES_URL = `${apiUrl}/rates`;

// AUTH
export const API_AUTH_URL = `${apiUrl}/auth`;
export const API_PERMISSIONS_URL = `${API_AUTH_URL}/FunctionalityPermissions`;
// OFFICES
export const OFFICES_URL = `${apiUrl}/offices`;
export const OFFICE_URL = `${apiUrl}/office`;
export const RELATED_PEOPLE_URL = `${apiUrl}/relatedpeople`;
export const BILLING_SERIES_URL = `${apiUrl}/billingserie`;

// COLLECTIONS
export const CUSTOMERS_COLLECTION = `${CUSTOMERS_URL}/collections`;
export const OFFICES_COLLECTION = `${OFFICES_URL}/collections`;

// MARKETING AREA
export const MARKETING_URL = `${apiUrl}/Marketing`;
export const MARKETING_AREA_URL = `${apiUrl}/SavingRates`;

// CONSULTATION
export const CONSULTATION_URL = `${apiUrl}/inquiries`;
export const CONSULTATION_RELATED_PEOPLE_URL = `${apiUrl}/relatedpeople`;
export const CONSULTATION_PROCESSORS_URL = `${apiUrl}/processor`;
export const CONSULTATION_REPORTS_URL = `${apiUrl}/reports`;
export const CONSULTATION_NOTICES_URL = `${apiUrl}/notices`;
export const CONSULTATION_NOTICES_NOT_REVIEWED_URL = `${apiUrl}/notices/notreviewed`;

// PROCEDURES
export const PROCEDURES_URL = `${apiUrl}/procedures`;

// GENERAL DOCUMENTS
export const GENERAL_DOCUMENTATION_URL = `${apiUrl}/ComercialConsultas`;
export const GENERAL_DOCUMENT_FILES = `${apiUrl}/DocumentFiles`;
export const DOCUMENTS_DIRECTORIES = `${apiUrl}/DocumentFiles/Directories`;

// BCN PRODUCTS
export const BCN_PRODUCTS_URL = `${apiUrl}/BcnProducts`;
export const PRODUCTS_URL = `${apiUrl}/products/pagination`;

// BCN FINAL PRODUCTS
export const BCN_FINAL_PRODUCTS_URL = `${apiUrl}/BcnFinalProducts`;
export const FINAL_PRODUCTS_URL = `${apiUrl}/finalproducts/pagination`;

// COMERCIAL BUSINESS
export const COMMERCIAL_BUSINESS_URL = `${apiUrl}/CommercialManagements`;
